module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"pt-BR":{"merchants":"Empresas","users":"Usuários","employee":"Usuários Employee"},"en-US":{"merchants":"Merchants","users":"Users","employee":"Employee Users"}}')
  delete Component.options._Ctor
}
